/** One place for every React Query cache key, so invalidation is not guesswork. */
export const qk = {
  videos: (scope: string) => ['videos', scope] as const,
  video: (id: string) => ['video', id] as const,
  videoShares: (id: string) => ['video-shares', id] as const,
  orgs: () => ['orgs'] as const,
  myInvites: () => ['my-invites'] as const,
  org: (id: string) => ['org', id] as const,
  branding: (orgId: string) => ['branding', orgId] as const,
  videoDefaults: () => ['video-defaults'] as const,
  notificationPrefs: () => ['notification-prefs'] as const,
  inbox: (unreadOnly = false) => ['inbox', unreadOnly ? 'unread' : 'all'] as const,
  inboxUnread: () => ['inbox-unread'] as const,
  tags: (q = '') => ['tags', q] as const,
  videoTags: (videoId: string) => ['video-tags', videoId] as const,
  viewers: (videoId: string) => ['viewers', videoId] as const,
  requestLinks: () => ['request-links'] as const,
  imports: () => ['imports'] as const,
  requestLink: (token: string) => ['request-link', token] as const,
  share: (shareId: string) => ['share', shareId] as const,
  comments: (shareId: string) => ['comments', shareId] as const,
  reactions: (shareId: string) => ['reactions', shareId] as const,
};
